import base from "../../baseurl";
import token from "../../getTk";

const Create = async (name, sportEventId, background) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const newS = await api
    .post("sport-galleries/create", {
      json: { name, sportEventId, background },
      timeout: false,
    })
    .json();
  return newS;
};

export default Create;
